<template>
<b-card-group deck
              class="mt-4 mb-4">
    <luma-domain-handles-selection  v-if="!updatePage"
                                    :config="$userConfig"
                                    :setup_mode="true"
                                    @emit_local_change="emit_local_change">
    </luma-domain-handles-selection>
    <luma-domain-nameserver-selection v-if="!updatePage"
                                      :config="$userConfig"
                                      :setup_mode="true"
                                      @emit_local_change="emit_local_change">
    </luma-domain-nameserver-selection>
    <luma-save-changes-button v-if="localChange && save_button"
                              @save="save"
                              :spinner="spinner">
    </luma-save-changes-button>
</b-card-group>
</template>

<script>

    import LumaOrderNsHdSettingsDomain from "../create_domain/luma-order-ns-hd-settings-domain";
    import LumaDomainHandlesSelection from "./luma-domain-handles-selection";
    import LumaDomainNameserverSelection from "./luma-domain-nameserver-selection";
    import LumaSaveChangesButton from "@/components/layout/luma-save-changes-button";
    import {DomainHandle} from "@/store/models/domain/domain_handle";
    import {Domain} from "@/store/models/domain/domain";
    import DomainNameserver from "@/store/models/domain/domain_nameserver";
    import UserConfigDefaults from "@/store/models/layout/user_config";

    export default {
        name: "domain-setup-view",
        components: {
            LumaSaveChangesButton,
            LumaDomainNameserverSelection,
            LumaDomainHandlesSelection,
            LumaOrderNsHdSettingsDomain},
        props:{
            save_button:Boolean
        },
        data:()=>({
            localChange:false,
            spinner:false,
            config:null,
            configPrefix: "domain.defaults",
            updatePage:null
        }),
        methods:{
            emit_local_change(data){
                console.log('dsv',data)
                this.config = Object.assign({},this.config,data)
                this.localChange = true
                this.emit_all_config()
            },
            save(){
                console.log('SETTINGS SAVE::', this.config)
                UserConfigDefaults.save(this.config, this.configPrefix)
                this.localChange = false
                this.spinner = false
            },
            emit_all_config(){
                this.$emit('emit_all_config', this.config)
            },
            async create_config(){
                const x = await JSON.parse(JSON.stringify(this.$userConfig))
                this.config = await Object.assign({},x)
                if (x.nameservers){
                    const keys = Object.keys(x.nameservers).map(el=>{
                            if(!this.config[el]){
                                this.config[el] = x.nameservers[el]
                            }
                        }
                    )
                }
            }
        },
        mounted(){
            this.updatePage = true
            setTimeout(()=>{
                this.updatePage = false
            },800)
        },
        created() {
            DomainHandle.fetchall()
            const x = Domain.contacts.map(el=>{
                DomainHandle.fetch(this.$userConfig[el],true)
            })
            this.create_config()
            DomainNameserver.fetch()
        }
    }

</script>

<style scoped>

  .rowClass{vertical-align: middle}
  .width1200{
    min-width: 300px;
    max-width: 1200px;
    display: inline-block;
  }
  .width400{
    float: right;
    vertical-align: top;
    max-width: 400px;
    min-width: 200px;
    display: inline-block;
  }
</style>




// WEBPACK FOOTER //
// src/components/domain/setup_domain/domain-setup-view.vue